module.exports = __webpack_public_path__ + "media/images/application/template/meganav/conversions/pop-up-container-shops-e25ad7f879551f557479589c63461ff7.png";